export default {
  title: '使用记录',
  description: '查看座位场地被活动和会议使用的情况。',
  export: '导出记录',
  totalRecords: '共 {count} 条使用记录',
  layoutsUsed: '{count} 个座位布置被使用',
  formsUsed: '{count} 张报名表格',
  allLayouts: '全部座位布置',
  allForms: '全部报名表格',
  searchPlaceholder: '搜索座位布置 / 报名表格 / 活动',
  layout: '座位布置',
  form: '报名表格',
  activity: '关联活动',
  usedAt: '使用时间',
  operator: '操作人',
  view: '查看',
  empty: '暂无使用记录',
  importedRoster: '导入名单',
  exportSuccess: '使用记录已导出',
  back: '返回',
  detailTitle: '查看座位安排',
  breadcrumbManage: '座位管理',
  breadcrumbRecords: '使用记录',
  properties: '属性面板',
  legendEmpty: '空位',
  legendAssigned: '已分配',
  canvasTip: '点击座位或桌台查看详情（只读，不可编辑）',
  canvasActivity: '活动：{name}',
  canvasSession: '场次：{name}',
  sortLabel: '排序',
  rosterAssigned: '已分配 {assigned} / {total} 人',
  emptyRoster: '暂无参会人员',
  sourceRegistration: '报名人员',
  sourceImported: '导入人员',
  selectSeatHintFirst: '点击座位或桌台',
  selectSeatHintSecond: '查看详细信息',
  progress: '已分配 {assigned} / {total} 个座位',
  readonly: '只读',
  rosterTitle: '参会人员名单',
  rosterProgress: '共 {count} 人',
  sortDefault: '默认顺序（待分配优先）',
  sortNameAsc: '姓名拼音 A-Z',
  sortNameDesc: '姓名拼音 Z-A',
  sortOrganization: '单位 / 姓名',
  sortSeat: '座位顺序',
  searchRoster: '搜索姓名 / 单位 / 职务',
  noOrganization: '暂无单位',
  seatNo: '第 {no} 位',
  unassigned: '待分配座位',
  seatProperties: '座位详情',
  unit: '所在单元',
  row: '排号',
  column: '列号',
  seatNumber: '座位编号',
  status: '分配状态',
  assignedStatus: '已分配',
  emptyStatus: '空位',
  emptySeat: '此座位为空',
  selectSeatHint: '点击座位或桌台查看详细信息'
}
